import React from 'react'

function QuestionUnlockBankInfo() {
  return (
    <div className="question-card">
      <span>
        This question bank is not active in your organization's account.
      </span>
    </div>
  )
}

export default QuestionUnlockBankInfo
